// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 584) return "js/584.js";
	if (chunkId === 945) return "js/945.js";
	// return url for filenames based on template
	return undefined;
};